import { isPlatformServer } from '@angular/common';
import { inject, Injectable, PLATFORM_ID, signal } from '@angular/core';

import { type INotificationCard } from '@rpgc-ai/shared-interfaces/interfaces/notifications.interfaces';

import { TranslateBackendService } from '../translate-backend/translate-backend.service';

@Injectable({
  providedIn: 'root',
})
export class NotificationsService {
  readonly platformId = inject(PLATFORM_ID);
  readonly #translateBackendService = inject(TranslateBackendService);

  readonly notifications = signal<INotificationCard[]>([]);

  /**
   * Добавление уведомления
   *
   * @param notification Уведомление
   */
  addNotification(notification: INotificationCard): void {
    if (isPlatformServer(this.platformId)) {
      return;
    }
    const notificationWithBackendTranslate: INotificationCard = {
      ...notification,
      text: this.#translateBackendService.backendMessageToKey(notification.text),
    };
    this.notifications.update((notifications) => [...notifications, notificationWithBackendTranslate]);
  }

  /**
   * Удаление уведомления
   *
   * @param id ID уведомления
   */
  removeNotification(id: string): void {
    this.notifications.update((notifications) => notifications.filter((n) => n.id !== id));
  }

  /**
   * Очистка уведомлений
   */
  clearNotifications(): void {
    this.notifications.set([]);
  }
}
